
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import React,{useEffect,useState} from 'react';

import { Link, useNavigate,useLocation } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import grclogo from '../../Images/GRC-Pulse-Logo.png';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { COLORS } from '../colors';
import LogoutIcon from '@mui/icons-material/Logout';
import { Email, Phone } from '@mui/icons-material';
import { SlCalender } from 'react-icons/sl';


const pages = ['Dashboard', 'Create', 'Vendors List', 'Master Data', 'Monthly Data'];
// const settings = ['Profile'];
export default function AssessorAppBar() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [masterAnchorEl, setMasterAnchorEl] = useState(null);
   const [createAnchorEl, setCreateAnchorEl] = useState(null);
  const [showProfileText, setShowProfileText] = useState(false);
  const [showLogoutText, setShowLogoutText] = useState(false);
  const [showCalenderText, setShowCalenderText] = useState(false)
      const [monthlyAnchorEl, setMonthlyAnchorEl] = useState(null);
 const [menuLabels, setMenuLabels] = useState({
  monthly: "Monthly Data",
  create: "Create",
  master : "Master Data"
 
});
  const navigate=useNavigate();
  const location = useLocation(); 
  
   const handleMenuClick = (key, label, path) => {
  setMenuLabels((prev) => ({ ...prev, [key]: label }));
  navigate(path);

};

const handleMenuClose = (menu) => {
  if (menu === "create") setCreateAnchorEl(null);
   if (menu === "master") setMasterAnchorEl(null);
  if (menu === "monthly") setMonthlyAnchorEl(null);
};

  
    const handleLogout = () => {
      navigate("/signin");
      sessionStorage.clear();
    };
  
    const handleCreateMenuOpen = (event) => {
  setCreateAnchorEl(event.currentTarget);
};




   const handleMasterMenuOpen = (event) => {
  setMasterAnchorEl(event.currentTarget);
};


 const handleMonthlyMenuOpen = (event) => {
  setMonthlyAnchorEl(event.currentTarget);
};


  const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
      };
    
      const handleCloseMenu = () => {
        setAnchorEl(null);
      };
    
      const handleProfileClick = () => {
        navigate('/profile/assessor'); 
        handleCloseMenu();
      };
    
      // const handleVendorsListClick = () => {
      //   navigate('/vendorList'); 
      //   handleCloseMenu();
      // };
     const isPageActive = (path) => location.pathname === path;

  return (
    <AppBar position="sticky" sx={{backgroundColor:'#1C1C1C	'}}>
      <Container maxWidth="xxl">

        <Toolbar disableGutters>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/assessordashboard"
              sx={{
                mr: 2,
                display: { xs: 'flex', md: 'flex' },
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.3rem',
                textDecoration: 'none',
              }}
            >
              <img
                src={grclogo}
                width="130px"
                alt="Company Logo"
                style={{
                  padding: '5px'
                }}
              />
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', fontSize: 12, color: COLORS.ivory }}>
            <Typography sx={{ mr: 1 }}>
  <a href="mailto:support@grcpulse.in" style={{ textDecoration: 'none', color: COLORS.ivory }}>
    <Email /> support@grcpulse.in
  </a>
</Typography>
              <Typography><Phone /> 080-31634351 <br/><span style={{ paddingLeft: '20px'}}>+91-8310163968 </span></Typography>
            </Box>
          </Box>
        </Toolbar>
     
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' ,backgroundColor:'#B22222'}}>
            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "flex" } }}>
            {pages.map((page) => {
  if (page === 'Master Data') {
    return (
      <div key={page}>
        
                 <Box
                              key={page}
                              sx={{
                                m: 2,
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                textTransform: 'none',
                                cursor: 'pointer',
                                width: 'auto',
                              }}
                              onClick={handleMasterMenuOpen}
          
                            >
          <Typography sx={{ fontSize: 15, color:
                   isPageActive("/vendorsmasterdata") ||
      isPageActive("/establishmentmasterdata")
        ? "white"
        : "#C0C0C0",
          }}>
            {menuLabels.master}
          </Typography>
           <Button
                                sx={{
                                  minWidth: 'auto',
                                  padding: 0,
                                  color: '#C0C0C0',
                                }}
          
                              >
                                <ArrowDropDownIcon  onClick={handleMasterMenuOpen} />
                              </Button>
        </Box>

        <Menu
          anchorEl={masterAnchorEl}
          open={Boolean(masterAnchorEl)}
          
        >
          <MenuItem onClick={() => {
            handleMenuClick('master','Vendors Master Data','/vendorsmasterdata');
          handleMenuClose('master')
            
            }}>
            Vendors Master Data
          </MenuItem>
          <MenuItem onClick={() => {
             handleMenuClick('master','Establishment Master Data','/establishmentmasterdata')
              handleMenuClose('master')
          }
             }>
            Establishment Master Data
          </MenuItem>
        </Menu>
      </div>
    );
  } 
  else if(page === 'Monthly Data'){
    return(
    <div key={page}>
                            
                                     <Box
                                                  key={page}
                                                  sx={{
                                                    m: 2,
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    textTransform: 'none',
                                                    cursor: 'pointer',
                                                    width: 'auto',
                                                  }}
                                                  onClick={handleMonthlyMenuOpen}
                              
                                                >
                              <Typography sx={{ fontSize: 15, color:
                                 isPageActive("/vendorsmonthlydata") ||
      isPageActive("/establishmentmonthlydata")
        ? "white"
        : "#C0C0C0",
                               }}>
                                {menuLabels.monthly}
                              </Typography>
                               <Button
                                                    sx={{
                                                      minWidth: 'auto',
                                                      padding: 0,
                                                      color: '#C0C0C0',
                                                    }}
                              
                                                  >
                                                    <ArrowDropDownIcon  onClick={handleMonthlyMenuOpen} />
                                                  </Button>
                            </Box>
                    
                            <Menu
                              anchorEl={monthlyAnchorEl}
                              open={Boolean(monthlyAnchorEl)}
         

                            >
                              <MenuItem 
                              selected={location.pathname === "/vendorsmonthlydata" }
 
                              onClick={() => {
                                handleMenuClick('monthly',' Vendors Monthly Data','/vendorsmonthlydata')
                               handleMenuClose('monthly')
                              }
                              }>
                               
                               
                                Vendors Monthly Data
                              </MenuItem>
                              <MenuItem onClick={() => {
                                 handleMenuClick('monthly',' Establishment Monthly Data','/establishmentmonthlydata')
                                   handleMenuClose('monthly')
                              }
                                 }>
                                Establishment Monthly Data
                              </MenuItem>
                            </Menu>
                          </div>
            )}
  else if(page === 'Create'){
    return(
       <div key={page}>
        
                 <Box
                              key={page}
                              sx={{
                                m: 2,
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                textTransform: 'none',
                                cursor: 'pointer',
                                width: 'auto',
                              }}
                              onClick={handleCreateMenuOpen}
          
                            >
          <Typography sx={{ fontSize: 15, color: 
             isPageActive("/createVendor") ||
      isPageActive("/establishmentMonthlydataCreatePage")
        ? "white"
        : "#C0C0C0",
          }}>
            {menuLabels.create}
          </Typography>
           <Button
                                sx={{
                                  minWidth: 'auto',
                                  padding: 0,
                                  color: '#C0C0C0',
                                }}
          
                              >
                                <ArrowDropDownIcon  onClick={handleCreateMenuOpen} />
                              </Button>
        </Box>

        <Menu
          anchorEl={createAnchorEl}
          open={Boolean(createAnchorEl)}
    

        >
          <MenuItem onClick={() => {
             handleMenuClick('create','Create Vendor Profile','/createVendor')
              handleMenuClose('create')
                              }
            }>
            Create Vendor Profile
          </MenuItem>
          <MenuItem onClick={() => {
            handleMenuClick('create','Create Establishment Monthly Data','/establishmentMonthlydataCreatePage')
            handleMenuClose('create')
          }
            }>
            Create Establishment Monthly Data
          </MenuItem>
        </Menu>
      </div>
    )
  }
  else {
    return (
      <Button
        key={page}
        sx={{
          m: 1,
          display: 'block',
          textTransform: 'none',
        }}
      >
        <Link
          className="nav-link"
          to={
    page === "Dashboard"
      ? "/assessordashboard"
      : page === "Vendors List"
      ? "/vendorslist"
      : `/${page.replace(/\s+/g, "").toLowerCase()}`
  }
          style={{ color: COLORS.ivory, textDecoration: 'none' }}
        >
          <Typography sx={{ fontSize: 15,
                                    color:
        page === "Dashboard"
          ? (isPageActive("/assessordashboard") || 
             isPageActive("/assessorestablishmentdashboard"))
            ? "white"
            : "#C0C0C0"
          : isPageActive(`/${page.replace(/\s+/g, "").toLowerCase()}`)
            ? "white"
            : "#C0C0C0"}}>

          
            {page}
          </Typography>
        </Link>
      </Button>
    );
  }
})}

            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title={showCalenderText ? 'Compliance Calendar' : ''}>

              <Link to="/complience-calender">
                <SlCalender 
                 onMouseEnter={() => setShowCalenderText(true)}
                 onMouseLeave={() => setShowCalenderText(false)}
                 size="1.6rem" color='#ffffff' />
              </Link>
              </Tooltip>
              <Tooltip title={showProfileText ? 'Profile' : ''}>
                <IconButton
                  onClick={handleOpenMenu} // Open menu when clicked
                  onMouseEnter={() => setShowProfileText(true)}
                  onMouseLeave={() => setShowProfileText(false)}
                  sx={{ p: 1 }}
                >
                  <AccountCircle sx={{ fontSize: '35px', color: COLORS.ivory }} onClick={() => handleProfileClick()} />
                </IconButton>
              </Tooltip>
              {/* <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}

              >
                {settings.map((setting) => (
                  <MenuItem
                    key={setting}
                    onClick={() => {
                      if (setting === 'Profile') {
                        handleProfileClick();
                      } else if (setting === 'Vendors List') {
                        handleVendorsListClick();
                      }
                    }}
                  >
                    <Typography textAlign="center">{setting}</Typography>
                  </MenuItem>
                ))}
              </Menu> */}


              <Tooltip title={showLogoutText ? 'Log Out' : ''}>
                <IconButton
                  onClick={handleLogout}
                  onMouseEnter={() => setShowLogoutText(true)}
                  onMouseLeave={() => setShowLogoutText(false)}
                  sx={{ p: 1 }}
                >
                  <LogoutIcon sx={{ fontSize: '30px', color: COLORS.ivory }} />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
     
      </Container>
    </AppBar>
  );
}
